import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeUnderscore',
    standalone: false
})
export class RemoveUnderscorePipe implements PipeTransform {

  transform(word: string): string | null{
    if (!word) {
      return null;
    }
    //replace all underscores with spaces
    return word.replaceAll(/_/g, ' ');
  }
}
